import React from 'react'
import img from 'assets/img/emptyreview.png'

function EmtpyReview() {
  return (
    <div className='w-100 h-[100%] flex flex-col items-center justify-center'>
      <div className='bg-[#D3D7DB] p-4 border rounded-[100%]'>
      <img src={img} alt="" />
      </div>
      <div>
        
        
No Data
      </div>
    </div>
  )
}

export default EmtpyReview